import { postRequest } from 'config/Axios/baseConfig';
import { StagingPriorityListResponse } from 'screens/StagingPriorityList/StagingPriorityListTypes';

export const getStagingPriorityListService = {
  getStagingPriorityList: (): Promise<StagingPriorityListResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await postRequest<StagingPriorityListResponse>(
          'pps/get-staging-priority-list/',
          { date: null }
        );
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
